import React from 'react';
import {Grid, IconButton} from "@material-ui/core";
import styled from "styled-components";
import {StyledInput} from "../../form/input";
import {FieldArray} from "formik";
import {StyledButton} from "../../ui-base/button";
import {Colors} from "../../../theme/colors";
import {CustomTrashIcon} from "../../ui-base/icons/custom-trash-icon";
import axios, {AxiosResponse} from "axios";
import {BibBookModel} from "../../../models/bib-book.model";
import {toggleLoader} from "../../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

const AddBookPrevious: React.FC<Props> = ({values, fieldName, handleChange, errors, touched, setFieldValue}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('author');

    const searchByIsbn = (isbn: string, fieldName: string, index: number) => {
        if (isbn) {
            dispatch(toggleLoader(true));
            axios.get('bn_search/?isbn=' + isbn).then((res: AxiosResponse<{bibs: BibBookModel[]}>) => {
                setFieldValue(`${fieldName}.${index}.json_bn`, res.data.bibs[0]);
                setFieldValue(`${fieldName}.${index}.name`, res.data.bibs[0]?.title);
                setFieldValue(`${fieldName}.${index}.publisher_bn`, res.data.bibs[0]?.publisher);
                dispatch(toggleLoader(false));
            });
        } else {
            setFieldValue(`${fieldName}.${index}.json_bn`, null);
        }
    }

    return (
        <>
            <StyledTitle>{t('addBookPrevious.lastPub')}:</StyledTitle>
            <FieldArray name={fieldName}>
                {({ remove, push }) => (
                    <Grid container spacing={2} direction="column">

                        {values[fieldName]?.length > 0 && values[fieldName].map((value, index) => {
                            return <Grid key={index} item container direction="row" spacing={1} style={{flexWrap: 'nowrap'}}>
                                    <Grid item container direction={"column"} style={{flex: 1}} spacing={1}>
                                        <Grid item>
                                            <StyledInput
                                                id={`${fieldName}.${index}.isbn`}
                                                label={t('addBookPrevious.isbn')}
                                                value={values[fieldName][index].isbn}
                                                onChange={handleChange}
                                                onBlur={() => {searchByIsbn(values[fieldName][index].isbn, fieldName, index)}}
                                                error={errors && errors[fieldName] && errors[fieldName][index]?.isbn && touched && touched[fieldName] && touched[fieldName][index]?.isbn}
                                            />
                                        </Grid>

                                        <Grid item>
                                            <StyledInput
                                                id={`${fieldName}.${index}.name`}
                                                label={t('addBookPrevious.title')}
                                                value={values[fieldName][index].name}
                                                onChange={handleChange}
                                                error={errors && errors[fieldName] && errors[fieldName][index]?.name && touched && touched[fieldName] && touched[fieldName][index]?.name}
                                            />
                                        </Grid>

                                        <Grid item>
                                            <StyledInput
                                                id={`${fieldName}.${index}.publisher_bn`}
                                                label={t('addBookPrevious.publisher')}
                                                value={values[fieldName][index].publisher_bn}
                                                onChange={handleChange}
                                                error={errors && errors[fieldName] && errors[fieldName][index]?.publisher_bn && touched && touched[fieldName] && touched[fieldName][index]?.publisher_bn}
                                            />
                                        </Grid>
                                    </Grid>

                                    {/*<Grid container item direction={"row"} alignItems={"flex-end"} justifyContent={"center"} style={{width: 'auto'}}>*/}
                                    {/*    <IconButton aria-label="delete" style={{color: '#000'}} onClick={() => {*/}
                                    {/*        searchByIsbn(values[fieldName][index].isbn, fieldName, index);*/}
                                    {/*    }}>*/}
                                    {/*        <SearchIcon/>*/}
                                    {/*    </IconButton>*/}
                                    {/*</Grid>*/}

                                    <Grid container item direction={"row"} alignItems={"center"} justifyContent={"center"} style={{width: 'auto'}}>
                                        <IconButton aria-label="delete" onClick={() => {
                                            remove(index);
                                        }}>
                                            <CustomTrashIcon style={{fill: 'transparent'}}/>
                                        </IconButton>
                                    </Grid>
                            </Grid>
                        })}

                        <Grid item>
                            <StyledButton type="button" color={"transparentViolet"} onClick={() => {
                                push({id: null, name: '', isbn: ''});
                            }}>
                                {t('addBookPrevious.add')}
                            </StyledButton>
                        </Grid>
                    </Grid>
                )}
            </FieldArray>
        </>
    );
}

export default AddBookPrevious;

interface Props {
    values: any,
    fieldName: any,
    handleChange: any,
    errors?: any,
    touched?: any,
    setFieldValue?: any
}

const StyledTitle = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.1rem;
  font-weight: 500;
`;

const StyledBookSpan = styled('span')`
  color: ${Colors.lightViolet};
`
